export const overrideChargeContants = {
    RESET: 'RESET',
    OVVERIDECHARGE_FETCHING: 'OVVERIDECHARGE_FETCHING',
    OVVERIDECHARGE_FETCHED: 'OVVERIDECHARGE_FETCHED',
    OVVERIDECHARGE_SUBMITTING: 'OVVERIDECHARGE_SUBMITTING',
    OVVERIDECHARGE_SUBMITTED: 'OVVERIDECHARGE_SUBMITTED',
    OVERRIDE_GET_WB: 'OVERRIDE_GET_WB',
    GET_OVERRIDE_CODE: 'GET_OVERRIDE_CODE',
    OVERRIDE_LIST: 'OVERRIDE_LIST',
}